//#region src/infrastructure/sleep.ts
var sleep = async (ms) => {
	return await new Promise((resolve) => setTimeout(resolve, ms));
};
//#endregion
export { sleep };

//# sourceMappingURL=sleep.js.map